// Restores the Helix Infrared Styler to the Le Chic Beauty catalog.
//
// lc-data.js builds LC.products by filtering the catalog through LC.retiredIds,
// which still lists helix-infrared-styler. Shopify sells it as an active product
// — $540, four colourways, stock in all of them — so the retirement left its
// product page on the bare Liquid fallback (lc-product.js returns early when
// LC.findProduct finds nothing) and dropped it from collection grids, search
// and recommendations.
//
// Restoring the record means repeating, for it alone, the two passes in
// lc-bridge.js that only ever ran over the products lc-data.js kept: asset-path
// rewriting, and the Shopify price/availability sync.
//
// The colourways are reconciled with Shopify here too. LC.bag.add matches the
// chosen option against the Shopify variant titles by exact string, and when
// nothing matches it quietly falls back to the first available variant — so the
// catalog's 'Rose Gold' (Shopify spells it 'Rose gold') would have put a Lilac
// in the cart, and 'Hot Pink' was missing from the catalog altogether.
(function () {
  var ID = 'helix-infrared-styler';

  if (!window.LC || !Array.isArray(LC.products) || typeof LC.asset !== 'function') return;
  if (LC.products.some(function (p) { return p.id === ID; })) return;

  var catalog = window.LC_CATALOG || [];
  var record = null;
  for (var i = 0; i < catalog.length; i++) {
    if (catalog[i].id === ID) { record = catalog[i]; break; }
  }
  if (!record) return;

  // Option names must equal the Shopify variant titles, listed in store order.
  record.options = [
    { name: 'Lilac',     image: 'images/products/helix-infrared-styler/01.jpg', sku: '68HIRS LAV' },
    { name: 'Rose gold', image: 'images/products/helix-infrared-styler/04.jpg', sku: '68HIRS RG' },
    { name: 'Black',     image: 'images/products/helix-infrared-styler/02.jpg', sku: '68HIRS B' },
    { name: 'Hot Pink',  image: 'images/products/helix-infrared-styler/03.jpg', sku: '68HIRS HP' }
  ];

  record.videos = [{
    title: 'Meet the Helix Infrared Styler',
    src: 'https://cdn.shopify.com/videos/c/vp/2fc94e0d43724bfc910064bacc5be923/2fc94e0d43724bfc910064bacc5be923.HD-720p-4.5Mbps-94760332.mp4',
    poster: 'https://cdn.shopify.com/s/files/1/0555/3333/8755/files/preview_images/2fc94e0d43724bfc910064bacc5be923.thumbnail.0000000000.jpg?v=1789672456'
  }];

  // Pass 1 — asset paths. Absolute URLs come back from LC.asset unchanged.
  record.images.forEach(function (image) { image.src = LC.asset(image.src); });
  record.options.forEach(function (option) {
    if (option.image) option.image = LC.asset(option.image);
  });
  record.videos.forEach(function (video) {
    if (video.poster) video.poster = LC.asset(video.poster);
    if (video.src) video.src = LC.asset(video.src);
  });

  // Pass 2 — live price and availability from the Shopify payload.
  var shop = (window.LC_SHOP_PRODUCTS || {})[ID];
  record.inShop = !!shop;
  if (shop) {
    record.price = shop.price / 100;
    record.available = shop.available;
    record.hasPlans = shop.plans > 0;
  }

  if (Array.isArray(LC.retiredIds)) {
    LC.retiredIds = LC.retiredIds.filter(function (id) { return id !== ID; });
  }

  // Put it back where the catalog had it, so collection ordering is unchanged.
  var at = LC.products.length;
  for (var j = catalog.indexOf(record) + 1; j < catalog.length; j++) {
    var found = LC.products.indexOf(catalog[j]);
    if (found !== -1) { at = found; break; }
  }
  LC.products.splice(at, 0, record);

  // Search builds its index lazily; drop any copy made before this ran.
  LC.searchIndex = null;
})();
